import React from 'react'

const initialState = {
    stories: [],
    story: [],
    loading: true,
};

const storiesReducer = (state = initialState, { type, payload }) => {

    switch (type) {


        case "FETCH_STORIES":

            return { ...state, data: payload, loading: false }
        case "FETCH_STORY":
            return { ...state, data: payload, loading: false }
        default:
            return state
    }
}

export default storiesReducer